import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format currency based on type
export function formatCurrency(amount, currency = 'XOF') {
  if (amount === null || amount === undefined) return '-';
  
  const formatters = {
    XOF: new Intl.NumberFormat('fr-FR', { 
      style: 'decimal',
      maximumFractionDigits: 0 
    }),
    EUR: new Intl.NumberFormat('fr-FR', { 
      style: 'currency', 
      currency: 'EUR' 
    }),
    USD: new Intl.NumberFormat('en-US', { 
      style: 'currency', 
      currency: 'USD' 
    })
  };
  
  const formatter = formatters[currency] || formatters.XOF;
  const formatted = formatter.format(amount);
  
  if (currency === 'XOF') {
    return `${formatted} FCFA`;
  }
  
  return formatted;
}

// Format date
export function formatDate(date) {
  if (!date) return '-';
  const d = new Date(date);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(d);
}

// Format date with time
export function formatDateTime(date) {
  if (!date) return '-';
  const d = new Date(date);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(d);
}

// Property type labels
export const propertyTypeLabels = {
  terrain: 'Terrain',
  maison: 'Maison',
  appartement: 'Appartement',
  local_commercial: 'Local Commercial',
  immeuble: 'Immeuble'
};

// Transaction type labels
export const transactionTypeLabels = {
  vente: 'Vente',
  location: 'Location'
};

// Status labels
export const statusLabels = {
  disponible: 'Disponible',
  reserve: 'Reserve',
  vendu: 'Vendu',
  loue: 'Loue',
  partiel: 'Partiellement loue'
};

// Payment status labels
export const paymentStatusLabels = {
  en_attente: 'En attente',
  partiel: 'Partiel',
  complete: 'Complété'
};

// Client type labels
export const clientTypeLabels = {
  acheteur: 'Acheteur',
  locataire: 'Locataire',
  vendeur: 'Vendeur',
  bailleur: 'Bailleur'
};

// Get status color class
export function getStatusColor(status) {
  const colors = {
    disponible: 'bg-green-100 text-green-800',
    reserve: 'bg-yellow-100 text-yellow-800',
    vendu: 'bg-blue-100 text-blue-800',
    loue: 'bg-purple-100 text-purple-800',
    partiel: 'bg-orange-100 text-orange-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}

// Get payment status color class
export function getPaymentStatusColor(status) {
  const colors = {
    en_attente: 'bg-yellow-100 text-yellow-800',
    partiel: 'bg-orange-100 text-orange-800',
    complete: 'bg-green-100 text-green-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}

// Bamako districts
export const bamakoDistricts = [
  'ACI 2000',
  'Badalabougou',
  'Hamdallaye',
  'Hippodrome',
  'Kalaban Coura',
  'Lafiabougou',
  'Magnambougou',
  'Niarela',
  'Quinzambougou',
  'Sotuba',
  'Torokorobougou',
  'Autre'
];
